// in src/OutOfHomeCampaign
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class DashboardLinkField extends Component {

    handleClick = () => {
        let record = this.props.record;
        window.open(`${record.dashboard_url}`, '_blank');
    }

    render() {

        let LinkStyle = {
            color:  '#3f51b5',
            textDecoration: 'none',
            cursor: 'pointer',
            background: 'none',
            border: 0,
            padding: 0
        };

        if(this.props.record.dashboard_url) {
            return <button style={LinkStyle} onClick={this.handleClick}>{this.props.record.name}</button>;
        }
        else {
            return this.props.record.name;
        }
    }
}

DashboardLinkField.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(DashboardLinkField);